import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img.png'
import _imports_1 from '../assets/recycle-bin.png'
import _imports_2 from '../assets/editproject.png'


const _hoisted_1 = { class: "main" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "projects"
}
const _hoisted_5 = { class: "project-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "project" }
const _hoisted_8 = { class: "img-text" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "options"
}
const _hoisted_12 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_NewProject = _resolveComponent("NewProject")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.projects.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: project.id,
                        class: _normalizeClass({ 'selected': _ctx.selectedProject?.id === project.id }),
                        onClick: ($event: any) => (_ctx.selectProject(project))
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(project.project_name) + " ", 1),
                          _createElementVNode("div", _hoisted_8, [
                            _cache[2] || (_cache[2] = _createElementVNode("img", {
                              class: "img",
                              src: _imports_0,
                              alt: ""
                            }, null, -1)),
                            _createElementVNode("label", _hoisted_9, _toDisplayString(project.nr_images), 1)
                          ])
                        ])
                      ], 10, _hoisted_6))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[3] || (_cache[3] = [
                  _createElementVNode("label", { class: "lblNoProjects" }, "NO PROJECTS FOUND", -1)
                ]))),
            (_ctx.projects.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["option", {'disabled':!_ctx.selectedProject || !_ctx.isAdmin}]),
                    src: _imports_1,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteProject && _ctx.deleteProject(...args)))
                  }, null, 2),
                  _createElementVNode("img", {
                    class: _normalizeClass(["option", { 'disabled': !_ctx.selectedProject || !_ctx.isAdmin }]),
                    src: _imports_2,
                    title: "Edit Project",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editSelectedProject && _ctx.editSelectedProject(...args)))
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Button, {
              class: _normalizeClass({'btnNoProjects': _ctx.projects.length === 0, 'disabled':!_ctx.selectedProject}),
              color: "#d1d1d1",
              onClick: _ctx.openProject
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("OPEN")
              ])),
              _: 1
            }, 8, ["class", "onClick"]),
            _createVNode(_component_Button, {
              class: _normalizeClass({ 'btnNoProjects': _ctx.projects.length === 0, 'disabled': !_ctx.selectedProject || !(_ctx.isAdmin || _ctx.isReviewer) }),
              color: "#d1d1d1",
              onClick: _ctx.openProjectForReview
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("REVIEW")
              ])),
              _: 1
            }, 8, ["class", "onClick"]),
            _createVNode(_component_Button, {
              color: "red",
              onClick: _ctx.Cancel
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("CANCEL")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isEditing && _ctx.editingProject)
      ? (_openBlock(), _createBlock(_component_NewProject, {
          key: 1,
          initialProject: _ctx.editingProject,
          isEditMode: true,
          onCancelNewProject: _ctx.cancelEdit
        }, null, 8, ["initialProject", "onCancelNewProject"]))
      : _createCommentVNode("", true)
  ]))
}